import type { ComponentType, TransitionEvent } from 'react';
import React, { Component } from 'react';
import cn from 'classnames';

import styles from './styles.css';
import type { IProps } from './models';

const makeAnimationStyles = (animationDuration: number, animationCubicBezier: string) => ({
    transitionDuration: `${animationDuration}s`,
    transitionTimingFunction: animationCubicBezier,
});

const makePositionStyles = (x: number, y: number) => ({
    transform: `translate(${x}px, ${y}px)`,
    willChange: 'transform',
});

export const MoveableContent = class extends Component<React.PropsWithChildren<IProps>> {
    static defaultProps: IProps = {
        noOverflow: false,
        animate: false,
        animationDuration: 1,
        animationCubicBezier: 'ease',
        animationDidEndCallback: undefined,
        x: 0,
        y: 0,
    };

    constructor(props: IProps) {
        super(props);

        this.onTransitionEnd = this.onTransitionEnd.bind(this);
    }

    onTransitionEnd(event: TransitionEvent<HTMLDivElement>) {
        const { animationDidEndCallback } = this.props;

        if (animationDidEndCallback === null) {
            return;
        }

        const { x, y } = this.props;

        if (animationDidEndCallback) {
            animationDidEndCallback({ x, y, event });
        }
    }

    render() {
        const { animate, animationCubicBezier, animationDuration, children, noOverflow, x, y } =
            this.props;

        let animationStyles = null;

        if (animate) {
            animationStyles = makeAnimationStyles(animationDuration, animationCubicBezier);
        }

        const positionStyles = makePositionStyles(x, y);

        return (
            <div
                className={cn(styles.movableContent, {
                    [styles.noOverflow]: noOverflow,
                    [styles.animate]: animate,
                })}
            >
                <div
                    className={styles.content}
                    onTransitionEnd={this.onTransitionEnd}
                    style={{
                        ...animationStyles,
                        ...positionStyles,
                    }}
                >
                    {children}
                </div>
            </div>
        );
    }
} as ComponentType<React.PropsWithChildren<Partial<IProps>>>;
